import { HateoasResource } from '@lagoshny/ngx-hateoas-client';
import { BaseServicePolicy } from './base-service-policy';

@HateoasResource('edge-router-policies')
export class EdgeRouterPolicyV2 extends BaseServicePolicy {
    endpointAttributes: string[];
    selected = false;
    isSystem = false;
}
